import React from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import { Typography } from "../../UIComponents/Wrappers";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
    list: {
        maxHeight: 150,
        overflow: 'auto',
        padding: 0,
        marginTop: 8,
    },
    listItem: {
        padding: '2px 0',
    },
    nameCol: {
        textAlign: 'left',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    dateCol: {
        textAlign: 'right',
        whiteSpace: 'nowrap',
    },
});

const HeadCountStat = ({ data }) => {
    const classes = useStyles();
    
    return (
        <Card>
            <CardContent style={{ textAlign: 'center', padding: 16 }}>
                <Typography variant="h6" gutterBottom>
                    {data.title}
                </Typography>
                <Typography variant="h3" weight="bold">
                    {data.value}
                </Typography>
                {data.employees && data.employees.length > 0 && (
                        <List className={classes.list}>
                            {data.employees.map((emp, index) => (
                                <ListItem key={emp.id || index} className={classes.listItem}>
                                    <Grid container alignItems="center">
                                        <Grid item xs className={classes.nameCol}>
                                            <Typography variant="body2">
                                                {emp.fullname || emp.orgID}
                                            </Typography>
                                        </Grid>
                                        <Grid item className={classes.dateCol}>
                                            <Typography variant="caption">
                                                {emp.dateLabel}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </ListItem>
                            ))}
                        </List>
                )}
            </CardContent>
        </Card>
    );
};

export default HeadCountStat;